import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import './Navbar.css';

import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import MenuRoundedIcon from '@material-ui/icons/MenuRounded';
import ContactPhoneIcon from '@material-ui/icons/ContactPhone';
import PermPhoneMsgRoundedIcon from '@material-ui/icons/PermPhoneMsgRounded';
import AccountCircleRoundedIcon from '@material-ui/icons/AccountCircleRounded';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';

import aiRenderLogo2 from '../../assets/aiRenderLogo2.png';
import iconMain from '../../assets/iconMain.png';

import {
    handle_activePage,
} from '../../Redux/reducer';
import {
    handleLogout,
    getAuthUser,
    getCartDetails,
    getBillNumber,
    getSubscriptionDetails,
} from '../../Redux/actions';

export const Navbar = () => {
    const dispatch = useDispatch();
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const activePage = useSelector((state) => state.auth.activePage);
    const user = useSelector((state) => state.auth.user);
    const invoice = useSelector((state) => state.auth.invoice);
    const [isMenu,setIsMenu] = useState(false);
    // let url = window.location.href
    // let lastSlashIndex = url.lastIndexOf("/");
    // const [activePage,setActivePage] = useState(url.substr(lastSlashIndex + 1));

    useEffect(
        () => {
            // dispatch(getAuthUser(user.email));
            // dispatch(getCartDetails(user.email));
            dispatch(getSubscriptionDetails(user.email, "Hi"));
            // console.log("lohith:Navbar:useEffect: outside if 1 : activePage = ", activePage);
            // if(activePage == "paymentResult?data=success" || activePage == "?data=success") {
            //     console.log("lohith:Navbar:useEffect: inside if 1");
            //     if(invoice.items.length > 0){
            //         console.log("lohith:Navbar:useEffect: inside if 2");
            //         dispatch(getBillNumber("receipt"));
            //     } else {
            //         console.log("lohith:Navbar:useEffect: inside else 2");
            //         window.location.replace("https://www.airender.co.in/");
            //     }
            // }
        },
        [1],
    );

    return(
        <nav className='navbar'>
            <ul className={isMenu ? 'nav-links-mobile' : 'nav-links'} 
                onClick={()=>setIsMenu(false)}
            >
                <Link to='/' className={activePage === "" ? 'home activeNav' : 'home'} onClick={()=>dispatch(handle_activePage(""))} >
                    <li>Home</li>
                    {activePage !== "" && !isMenu ? <div className='navUnderlineDot'></div> : <></>}
                </Link>
                <Link to='/hi' className={activePage === "hi" ? 'hi activeNav' : 'hi'} onClick={()=>dispatch(handle_activePage("hi"))} >
                    <li>hi</li>
                    {activePage !== "hi" && !isMenu ? <div className='navUnderlineDot'></div> : <></>}
                </Link>
                <Link to='/hiLite' className={activePage === "hiLite" ? 'hiLite activeNav' : 'hiLite'} onClick={()=>dispatch(handle_activePage("hiLite"))}>
                    <li>hiLite</li>
                    {activePage !== "hiLite" && !isMenu ? <div className='navUnderlineDot'></div> : <></>}
                </Link>
                <Link to='/hiRender' className={activePage === "hiRender" ? 'hiRender activeNav' : 'hiRender'} onClick={()=>dispatch(handle_activePage("hiRender"))}>
                    <li>hiRender</li>
                    {activePage !== "hiRender" && !isMenu ? <div className='navUnderlineDot'></div> : <></>}
                </Link>
                {/* <Link to='/blogs' className={activePage === "blogs" ? 'blogs activeNav' : 'blogs'} onClick={()=>dispatch(handle_activePage("blogs"))}>
                    <li>Blogs</li>
                    {activePage !== "blogs" && !isMenu ? <div className='navUnderlineDot'></div> : <></>}
                </Link> */}
                {/* <Link to='/payment' className={activePage === "payment" ? 'payment activeNav' : 'payment'} onClick={()=>dispatch(handle_activePage("payment"))}>
                    <li>Payment</li>
                    {activePage !== "payment" && !isMenu ? <div className='navUnderlineDot'></div> : <></>}
                </Link> */}
                {/* <Link to='/paymentResult' className={activePage === "paymentResult" ? 'paymentResult activeNav' : 'paymentResult'} onClick={()=>dispatch(handle_activePage("paymentResult"))}>
                    <li>PaymentResult</li>
                    {activePage !== "paymentResult" && !isMenu ? <div className='navUnderlineDot'></div> : <></>}
                </Link> */}
                <Link to='/services' className={activePage === "services" ? 'services activeNav' : 'services'} onClick={()=>dispatch(handle_activePage("services"))}>
                    <li>Services</li>
                    {activePage !== "services" && !isMenu ? <div className='navUnderlineDot'></div> : <></>}
                </Link>
                {user.email === "admin@airender.tech" 
                ?   <Link to='/admin' className={activePage === "admin" ? 'admin activeNav' : 'admin'} onClick={()=>dispatch(handle_activePage("admin"))}>
                    <li>Admin</li>
                    {activePage !== "admin" && !isMenu ? <div className='navUnderlineDot'></div> : <></>}
                </Link>
                : null}
                {isAuthenticated
                ?<Link className='logout' to='/contact' onClick={() => dispatch(handleLogout())}>
                    <li>Logout</li>
                </Link>
                : activePage == ""
                    ? <a href="#contact" className='login'>
                        <li>Join us</li>
                    </a>
                    :<Link   
                        href="#contact" 
                        className='login' 
                        to='/contact'
                        onClick={()=>dispatch(handle_activePage("contact"))}
                    >
                        <li>Join us</li>
                    </Link>
                }
            </ul>
            
            <div className='nav-icon-links'>
                <Link to='/' onClick={()=>dispatch(handle_activePage(""))} className="logoDiv">
                    <img className='logo' 
                        src={ (activePage === 'hi' || activePage === 'hiLite' || activePage === 'hiRender') 
                            ? iconMain  
                            : aiRenderLogo2 } 
                        alt='aiRenderLogo'
                    />
                </Link>
                {/* {console.log("lohith:Navbar:activePage = ",activePage)} */}
                {activePage == ""
                ? <a   
                    href="#contact" 
                    className='contactPhone' 
                    // onClick={()=>window.open("http://localhost:3000/#contact","_self")}
                >
                    <PermPhoneMsgRoundedIcon fontSize="large" />
                </a>
                :<Link   
                    href="#contact" 
                    className='contactPhone' 
                    to='/contact'
                    onClick={()=>dispatch(handle_activePage("contact"))}
                >
                    <PermPhoneMsgRoundedIcon fontSize="large" />
                </Link>}
                
                
                { 
                    isAuthenticated
                    ?   <a className='mobile_logout'>
                            <div className="dropdown">
                                {/* <button className="dropbtn">Dropup</button> */}
                                <AccountCircleRoundedIcon fontSize="large"/>
                                <div className="dropdown-content">
                                    <div className="dropdown-username">{user.fullName ? user.fullName : user.name}</div>
                                    {/* <a className="dropdown-logout" onClick={() => dispatch(handleLogout())}>Logout</a> */}
                                    <Link 
                                        className='dropdown-logout' 
                                        to='/contact' 
                                        onClick={() => dispatch(handleLogout())}
                                    >
                                        Logout 
                                        <PowerSettingsNewIcon style={{float:"right"}}/>
                                    </Link>
                                    {/* <a href="#">Link 3</a> */}
                                </div>
                            </div>
                        </a>
                    :   null 
                }
                <button className='mobile-menu-icon' onClick={()=>setIsMenu( isMenu ? false : true )}>
                {
                    isMenu 
                    ?   <CloseRoundedIcon fontSize="large" />
                    :   <MenuRoundedIcon fontSize="large" />
                }
                </button>
            </div>
            
        </nav>
        
    )
}

export default Navbar;